module.exports = __webpack_public_path__ + "static/media/logo.24280efc.svg";